module.exports = __webpack_public_path__ + "media/src/images/icon__sad--0--dark-a623d3d79c1920577fcdc520c9b60aff.png";